import * as React from 'react';
import iconUrl from '../../../assets/kickoff-branching-static.svg';

const StaticBranchIcon: React.FC = () => {
    return <img src={iconUrl} />;
};

export default StaticBranchIcon;
